import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import * as Cookies from 'js.cookie'
import AuthModule from './modules/Authentication/AuthModule'
import UserModule from './modules/ManageUsers/UserModule'
import CountryModule from './modules/ManageCountries/CountryModule'
import StateModule from './modules/ManageStates/StateModule'
import CountyModule from './modules/ManageCounties/CountyModule'
import defaultStoreStates from './defaultStoreStates'
import JurisdictionModule from './modules/ManageJurisdictions/JurisdictionModule'
import PublisherModule from './modules/ManagePublishers/PublisherModule'
import CodeYearModule from './modules/ManageCodeYears/CodeYearModule'
import AdoptionProfileModule from './modules/ManageAdoptionProfiles/AdoptionProfileModule'
import AdoptionStatusModule from './modules/ManageAdoptionStatuses/AdoptionStatusModule'
import AdoptionTypeModule from './modules/ManageAdoptionTypes/AdoptionTypeModule'
import CodeBookModule from './modules/ManageCodeBooks/CodeBookModule'
import AdoptionLabelModule from './modules/ManageAdoptionLabels/AdoptionLabelModule'
import AdoptionModule from './modules/ManageAdoptions/AdoptionModule'
import PostalCodeModule from './modules/ManagePostalCodes/PostalCodeModule'
import AuditLogModule from './modules/ManageAuditLogs/AuditLogModule'
import FESearchModule from './frontendModules/Search/searchModule'
import FEMapModule from './frontendModules/Map/mapModule'
import ICodeModule from './frontendModules/ICodesMap/icodeMapModule'
import AdminVersionModule from './modules/ManageVersion/AdminVersionModule'
import LocationEntityImportModule from './modules/ManageLocationEntityImport/LocationEntityImportModule'
import TownshipModule from './modules/ManageTownships/TownshipModule'
import SampleDownloadModule from './modules/ManageSampleDownload/SampleDownloadModule'
import ICodeColorModule from './modules/ManageICodeColors/ICodeColorModule'
import CountryDetailModule from './frontendModules/CountryDetails/coutryDetailsModule'
import ImportStatusModule from './modules/ImportStatus/ImportStatusModule'

Vue.use(Vuex)
const storeModules = {
  AuthModule,
  UserModule,
  CountryModule,
  StateModule,
  CountyModule,
  JurisdictionModule,
  PublisherModule,
  CodeYearModule,
  AdoptionProfileModule,
  AdoptionStatusModule,
  AdoptionTypeModule,
  CodeBookModule,
  AdoptionLabelModule,
  AdoptionModule,
  PostalCodeModule,
  AuditLogModule,
  FESearchModule,
  FEMapModule,
  ICodeModule,
  AdminVersionModule,
  LocationEntityImportModule,
  TownshipModule,
  SampleDownloadModule,
  ICodeColorModule,
  CountryDetailModule,
  ImportStatusModule
}

const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
const date = new Date(tz)
date.setTime(date.getTime() + (3600 * 1000))

export const store = new Vuex.Store({
  namespaced: true, // NameSpaced module
  modules: storeModules,
  plugins: [createPersistedState({
    paths: ['AuthModule'],
    storage: {
      getItem: key => Cookies.get(key),
      setItem: (key, value) => Cookies.set(key, value, { expires: date }),
      removeItem: key => Cookies.remove(key)
    }
  })],
  state: {
    DashBoard_Message: 'Welcome to Dashboard Page!'
  },
  mutations: {
    /**
    * Reset all states (including modules local states) to default state from local storage
    */
    resetAllStatesToDefault (state) {
      try {
        this.replaceState(Object.assign(state, defaultStoreStates()))
        localStorage.clear()
      } catch (error) {
      }
    }
  },
  actions: {
    /**
     * Action to call mutation for resetting all the modules states to default
     */
    resetStoreState ({ commit }) {
      // resets state of all the modules
      commit('resetAllStatesToDefault')
    }
  },
  getters: {
    headers: state => state.headers,
    users: state => state.users
  }
})
